import React from 'react';
import { Flex, Text, Image, Divider, useTheme } from '@aws-amplify/ui-react';
import { I18n } from 'aws-amplify';
import { useLabelOptions } from 'contexts/labelOptionsContext';
import DokkaLogo from 'components/Authenticator/images/DOKKA.svg';

const FormHeader = ({ titleTranslationKey }) => {
    const { tokens } = useTheme();
    const { labelOptions } = useLabelOptions();

    return (
        <Flex direction="column" alignItems="center" gap={tokens.space.large}>
            <Image
                alt={labelOptions.logo.alt}
                src={labelOptions.isWL ? labelOptions.logo.src : DokkaLogo}
                maxWidth={160}
                maxHeight={105}
            />
            <Divider borderColor={tokens.colors.brand.primary[80]} width={120} marginTop={tokens.space.xs} />
            <Text
                fontSize={tokens.fontSizes.xl}
                fontWeight={tokens.fontWeights.semibold}
                color={tokens.colors.font.primary}
            >
                {I18n.get(titleTranslationKey)}
            </Text>
        </Flex>
    );
};

export default FormHeader;
